export default {
    state: {
        list: null,
        count: null,

        filters: {
            search: "",
            orderBy: "data",
            desc: true,
            devices: [],
            date: {
                min: null,
                max: null,
            },
            establishments: [],
            local: [],
            advertising: []
        },
    },

    mutations: {
        COMMENTS_SET_LIST(state, list) {
            state.list = list;
        },

        COMMENTS_SET_COUNT(state, count) {
            state.count = count;
        },

        COMMENTS_SET_FILTER(state, { key, value }) {
            state.filters = {
                ...state.filters,
                [key]: value,
            };
        },

        COMMENTS_RESET_FILTERS(state) {
            state.filters = {
                search: "",
                orderBy: "data",
                desc: true,
                devices: [],
                date: {
                    min: null,
                    max: null,
                },
                establishments: [],
                local: [],
                advertising: []
            };
        },
    },
};
